import { useTranslation } from "next-i18next";

import Icon from "@components/Icon";
import { useMessage } from "@components/Message";
import useDidUpdateEffect from "@hooks/useDidUpdateEffect";
import scrollToTheTop from "@lib/scrollToTheTop";

import { OrderFields, ORDER_MESSAGE_ZONE } from "../../constants";
import useOrderData from "../../context/useOrderData";
import useOrderFieldsLoading from "../../context/useOrderFieldsLoading";
import useOrderFormik from "../useOrderFormik";

const useCheckOfferAvailable = (): void => {
  const { t } = useTranslation();

  const {
    dynamicData: { offers },
  } = useOrderData();

  const {
    values: { [OrderFields.DELIVERY_METHOD]: deliveryMethod },
  } = useOrderFormik();

  const { isFieldLoading } = useOrderFieldsLoading();
  const isOfferLoading = isFieldLoading(OrderFields.OFFER_GROUP_ID);

  const setMessage = useMessage();

  useDidUpdateEffect(() => {
    // If no offers available at all, there will be another error message.
    if (!offers.length || isOfferLoading) {
      return;
    }

    const selectedOffer = offers.find(
      ({ deliveryMethod: offerDeliveryMethod }) => offerDeliveryMethod === deliveryMethod
    );

    if (!selectedOffer) {
      setMessage({
        message: t("order-message-offer_not_available_for_delivery_method"),
        props: {
          variant: "error",
          icon: <Icon icon="warning" size="1.45rem" />,
          canClose: true,
          padding: "0.45rem 0.75rem",
        },
        zone: ORDER_MESSAGE_ZONE,
      });
      scrollToTheTop();
    }
  }, [deliveryMethod, offers, isOfferLoading, setMessage, t]);
};
export default useCheckOfferAvailable;
